module.exports = __webpack_public_path__ + "static/media/bets_closing.ae1549f0.mp3";